import { useMutation } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { reviseEmail, type ReviseEmailPayload, type ReviseEmailResponse } from "./api"

export function useReviseEmail() {
  const getContext = useApiContext()

  return useMutation<ReviseEmailResponse, Error, ReviseEmailPayload>({
    mutationFn: async (payload: ReviseEmailPayload) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return reviseEmail(context, payload)
    },
    meta: { errorToast: { fallback: "Failed to revise email" } },
  })
}
